module.exports = __webpack_public_path__ + "static/img/4.a3505636.png";